<template
  ><div>
    <!-- wwr window table -->
    <table class="wwrTable">
      <thead>
        <tr class="table-heading-wwr3B">
          <td colspan="9">WWR Window</td>
        </tr>
        <tr class="grey-row-3B">
          <td style="width:40px">Orientation</td>
          <template  v-for="(orient,j) in step3B.wwrWindowArrObj" ><td :key="j" style="width:40px"  v-if="orient.windowOrientationWwr!==0">{{ orient.windowOrientation }}</td></template>
        </tr>
        <tr>
          <td style="width:40px" class="grey-row-3B">WWR (glass+frame) <span class="highlight_units">%</span></td>
       <template  v-for="(orient,m) in step3B.wwrWindowArrObj">   <td :key="m" style="width:40px" class="input-row-3B" v-if="orient.windowOrientationWwr!==0"  >{{ orient.windowOrientationWwr }}</td></template>
        </tr>
        <tr>
          <td style="width:40px" class="grey-row-3B">Opening Area <span class="highlight_units">(sq.M)</span> </td>
        <template  v-for="orient in step3B.wwrWindowArrObj">  <td style="width:40px" class="value-row-3B"  v-if="orient.windowOrientationWwr!==0">{{ orient.calcWindowOpeningArea || +0 }}</td></template>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <!-- window type table -->
    <table class="windowTypeTable">
      <thead>
        <tr class="table-heading-windowType">
          <td colspan="10">Window Type</td>
        </tr>
        <tr>
          <td  style="background-color:#dedede;width:80px">Window</td>
          <td style="background-color:#dedede;width:180px">Window Type</td>
          <template  v-for="(orient, j) in step3B.windowTypeArrObj[0].orientationObj">
          <td v-if="orient.inputOrientationPercent!==0" style="background-color:#dedede;width:40px" >{{ orient.orientation }}</td>
          </template>
        </tr>
        <tr v-for="(window, i) in step3B.windowTypeArrObj" :key=" i">
          <td style="background-color:#dedede">{{ window.window_serial }}</td>
          <td>{{ window.window_type.type || `----` }}</td>
          <template v-for="(orient, j) in window.orientationObj">
          <td v-if="orient.inputOrientationPercent!==0" style="background-color: #c4def5"  >{{ orient.inputOrientationPercent }}</td>
          </template>
        </tr>
      </thead>
    </table>
    <!-- Openable Area Table -->
    <table class="openableAreaTable">
      <thead>
        <tr class="table-heading-openableArea">
          <td colspan="10">Openable Area</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="background-color:#dedede;width:80px">Orientation</td>
          <td style="background-color:#dedede;width:180px">Openable Percent</td>
          <template v-for="(orientationObj, k) in step3B.windowTypeArrObj[0].orientationObj">
          <td style="background-color:#dedede;width:40px" v-if="orientationObj.calcOpenableArea !==0" >{{ orientationObj.orientation }}</td>
          </template>
        </tr>
        <tr v-for="(window, n) in step3B.windowTypeArrObj">
          <td>
            {{ window.window_serial }}
              <td >{{ (window.window_type.openablePercent +'%') || 0 +`%` }}</td>
          </td>
          <template v-for="(orientationObj, k) in window.orientationObj">
          <td  v-if="orientationObj.calcOpenableArea">{{ orientationObj.calcOpenableArea }}</td>
          </template>
        </tr>
      </tbody>
    </table>
     <!-- Glass Area Table -->
    <table class="openableAreaTable">
      <thead>
        <tr class="table-heading-openableArea">
          <td colspan="10">Glass Area</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="background-color:#dedede;width:80px">Orientation</td>
          <td style="background-color:#dedede;width:180px">Input glass %</td>
          <template v-for="(orientationObj, k) in step3B.windowTypeArrObj[0].orientationObj">
            
          <td style="background-color:#dedede;width:40px" v-if="orientationObj.calcOpenableArea !==0"  >{{ orientationObj.orientation }}</td>
          </template>

        </tr>
        <tr v-for="(window, n) in step3B.windowTypeArrObj">
          <td>
            {{ window.window_serial }}
              <td>{{ (window.input_glass_percent +'%') || `0 %` }}</td>
          </td>
          <template v-for="(orientationObj, k) in window.orientationObj">
          <td v-if="orientationObj.calcGlassArea">{{ orientationObj.calcGlassArea }}</td>
          </template>
        </tr>
      </tbody>
    </table>
     <!-- Opaque Area Table -->
    <table class="openableAreaTable">
      <thead>
        <tr class="table-heading-openableArea">
          <td colspan="10">Opaque Area</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="background-color:#dedede;width:80px">Orientation</td>
          <td style="background-color:#dedede;width:180px">Opaque %</td>
          <template v-for="(orientationObj, k) in step3B.windowTypeArrObj[0].orientationObj">
          <td style="background-color:#dedede;width:40px" v-if="orientationObj.calcOpenableArea !==0" >{{ orientationObj.orientation }}</td>
          </template>
        </tr>
        <tr v-for="(window, n) in step3B.windowTypeArrObj">
          <template >
           <td > 
            {{ window.window_serial }}
              <td >{{ (window.opaque_percent +'%') || `0 %` }}</td>
           </td>
           <template v-for="(orientationObj, k) in window.orientationObj">
           <td v-if="orientationObj.calcOpenableArea !==0">{{ orientationObj.calcOpaqueArea || 0  }}</td>
        </template>
      
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
step3A: {
      get: function() {
        return this.$store.state.schema.inputs.step3A;
      },
      set: function(step3A) {
        this.$store.dispatch('setStep3A', step3A);
      },
    },
    step3B: {
      get: function() {
        return this.$store.state.schema.inputs.step3B;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3B', step3B);
      },
    },
  },
};
</script>

<style lang="scss">
.wwrTable {
  // margin: 8px 0px;
  padding: 12px;
  width: 100%;
  font-size: 12px;

  // border: 1px solid #a4abb3;
  border-spacing: 0px;
  .table-heading-wwr3B {
    background-color: #c4def5;
    padding: 4px;
    font-size: 16px;
    background-color: #c8f0e0;
    color: #2cb17c;
  }
  tr {
    // border: 1px solid #a4abb3;
    // border-spacing: 0px;
  }
  td {
    border: 1px solid #a4abb3;
    border-spacing: 0px;
    padding: 2px;
    text-align: center;
  }
  .grey-row-3B {
    background-color: #dedede;
  }
  .input-row-3B {
    background-color: #c4def5;
  }
}
.windowTypeTable {
  padding: 12px;
  width: 100%;
  font-size: 12px;

  // border: 1px solid #a4abb3;
  border-spacing: 0px;
  .table-heading-windowType {
    // background-color: #c4def5;

    padding: 4px;
    font-size: 16px;
    background-color: #c8f0e0;
    color: #2cb17c;
    text-align: center;
  }
  td {
    border: 1px solid #a4abb3;
    text-align: center;
  }
}

.openableAreaTable {
  // margin: 8px 0px;
  padding: 12px;
  width: 100%;
  font-size: 12px;

  // border: 1px solid #a4abb3;
  border-spacing: 0px;
  .table-heading-openableArea {
    background-color: #c4def5;
    padding: 4px;
    font-size: 16px;
    background-color: #c8f0e0;
    color: #2cb17c;
  }
  tr {
    // border: 1px solid #a4abb3;
    // border-spacing: 0px;
  }
  td {
    border: 1px solid #a4abb3;
    border-spacing: 0px;
    padding: 2px;
    text-align: center;
  }
}
</style>
